import './accordion-inline-item.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import Text from '../../typography/text/index.js';
import styles from './accordion-inline-item.module.scss.js';
import AccordionAnimation from './accordion-animation.js';
import DownCaretBold from '../../icons/component-icons/down-caret-bold/index.js';

const AccordionInlineItem = (_a) => {
    var _b;
    var { surface: surfaceProps = 'lightPrimary', header, disabled, children, activeItem, id, opened = false, onClick } = _a, rest = __rest(_a, ["surface", "header", "disabled", "children", "activeItem", "id", "opened", "onClick"]);
    const [open, setOpen] = useState(opened);
    useEffect(() => {
        if (activeItem && activeItem !== id && open) {
            setOpen(false);
        }
    }, [activeItem]);
    const surface = surfaceProps.toLowerCase();
    const accordionInlineStyles = [styles.itemButtonWrapper, styles[surface]];
    const itemTitleWrapperStyles = [styles.itemTitleWrapper];
    const hitAreaStyles = [styles.hitArea];
    const iconStyles = [styles.itemIconWrapper, styles[surface]];
    const itemContentWrapperStyles = [styles.itemContentWrapper, styles[surface]];
    if (open && !disabled) {
        accordionInlineStyles.push(styles.open);
        itemContentWrapperStyles.push(styles.open);
    }
    if (disabled) {
        iconStyles.push(styles.disabled);
        accordionInlineStyles.push(styles.disabled);
        hitAreaStyles.push(styles.disabled);
    }
    switch (header === null || header === void 0 ? void 0 : header.size) {
        case 'large':
        case 'medium':
            iconStyles.push(styles[header.size]);
            break;
        case 'small':
        default:
            iconStyles.push(styles.small);
    }
    if ((header === null || header === void 0 ? void 0 : header.textAlignment) === 'center') {
        itemTitleWrapperStyles.push(styles.center);
    }
    const _onClick = (e) => {
        if (header && header.onClick)
            header.onClick(e);
        if (onClick)
            onClick(id);
        setOpen(!open);
    };
    const calcIconSize = () => {
        switch (header === null || header === void 0 ? void 0 : header.size) {
            case 'large':
                return 20;
            case 'medium':
                return 16;
            default:
                return 12;
        }
    };
    const calcTextSize = () => {
        switch (header === null || header === void 0 ? void 0 : header.size) {
            case 'large':
                return 'small';
            case 'medium':
                return 'xsmall';
            default:
                return 'large';
        }
    };
    const calcTextKind = () => {
        switch (header === null || header === void 0 ? void 0 : header.size) {
            case 'large':
            case 'medium':
                return 'title';
            case 'small':
            default:
                return 'body';
        }
    };
    const height = open ? 'auto' : 0;
    return (jsxs("div", { children: [header && (jsxs("button", Object.assign({ role: header.role, tabIndex: header.tabIndex, "aria-label": header.ariaLabel, "aria-hidden": header.ariaHidden, disabled: disabled, className: accordionInlineStyles.join(' '), onClick: _onClick }, rest, { children: [jsx("span", { className: hitAreaStyles.join(' ') }), jsx("div", { className: itemTitleWrapperStyles.join(' '), children: jsxs(Text, Object.assign({ kind: calcTextKind(), size: calcTextSize(), bold: true, color: `var(--vds-color-element-primary-on${surface})` }, header.title, { tooltip: undefined, primitive: "span", children: [(_b = header.title) === null || _b === void 0 ? void 0 : _b.children, jsx("div", { className: iconStyles.join(' '), children: jsx(DownCaretBold, { iconName: "down-caret-bold", color: `var(--vds-color-element-primary-on${surface})`, size: calcIconSize(), ariaLabel: header.ariaLabel, ariaHidden: header.ariaHidden }) })] })) })] }))), jsx(AccordionAnimation, { height: height, opened: open, children: jsx("div", { className: itemContentWrapperStyles.join(' '), children: children }) })] }));
};

export { AccordionInlineItem as default };
